import ReactPlayer from 'react-player'
import React, { useState, useEffect, useRef } from 'react'
// import { Dialog, DialogContent } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import { castPhotos, galleryPhotos } from '../data'
import Video from 'yet-another-react-lightbox/plugins/video'
import logo from '../logo.png'
import LaurelScroller from '../components/LaurelScroller'
import HeroLaurels from '../components/HeroLaurels'
import SiteFooter from '../components/SiteFooter'
const videoUrl = '/assets/Girl-with-Piano-Trailer-no-text.mp4'
const FILM_YOUTUBE_ID = 'vSgM75wn9Mo'
const TRAILER_YOUTUBE_ID = 'sC02BQza_YU'


const ContactForm = () => {
  // const { isMobile } = useOutletContext()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        console.log('Form submitted successfully');
        setFormData({ name: '', email: '', message: '' });
        setSubmitStatus('success');
        setTimeout(() => setSubmitStatus(null), 5000); // Clear success message after 5 seconds
      } else {
        console.error('Form submission failed');
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group" style={{ justifyContent: 'space-between' }}>
        <div>
          <label htmlFor="name" className="form-label">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter your name"
          />
        </div>
        <div>
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter your email"
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="message" className="form-label">Message</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="form-textarea"
          placeholder="Enter your message"
          rows="5"
        ></textarea>
      </div>
      <button type="submit" className="submit-button" disabled={submitStatus === 'submitting'}>
        {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
      {submitStatus === 'success' && (
        <div className="success-message">Thank you for your message. We'll get back to you soon!</div>
      )}
      {submitStatus === 'error' && (
        <div className="error-message">An error occurred. Please try again later.</div>
      )}
    </form>
  );
};

const Trailer = ({ setShowTrailer, isMobile, isLandscape }) => {
  const [playing, setPlaying] = useState(isMobile)
  return (
    <header data-tone='dark' className={`trailer-header ${isMobile ? 'mobile' : ''} ${isLandscape ? 'landscape' : ''}`}>
      <div className='bg-vid'
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        onMouseEnter={() => { if (!isMobile) { setPlaying(true) } }}
        onClick={() => { if (isMobile) { setShowTrailer(true) } else { setPlaying(true) } }}>
        <ReactPlayer
          config={ { file: { attributes: {
            poster: '/assets/gap/header-bg.jpg',
            // without playsInline a phone takes the video fullscreen instead
            // of playing it in place, and refuses to autoplay
            playsInline: true,
            preload: 'auto',
          } } } }
          url={videoUrl} width='100%' height='100%' style={{ position: 'absolute', top: 0, left: 0 }} playing={playing} loop muted />
      </div>
      <div className={`video-overlay ${isMobile ? 'mobile' : ''}`}>
        <div className='overlay-content'>
          <div className='flex-grid'>
            <div className='grid-item header-title'>
              <img src={logo} alt='The Girl and Her Piano' className='header-logo'/>
            </div>
            <div className='grid-item trailer-info'>
              <div className={`horizontal-grid ${isMobile ? 'mobile' : ''}`}>
                <div className='grid-item narrator-info-grid-item'>
                  <div>
                    <button className='trailer-button' onClick={() => document.getElementById('watch')?.scrollIntoView({ behavior: 'smooth' })} style={{ pointerEvents: 'initial' }}>
                      Watch Full Film
                    </button>
                  </div>
                </div>
                <div className='grid-item'>
                </div>
              </div>
              <div className='film-details-container'>
                <h3 className='film-details'>
                  SHORT DOCUMENTARY . 11m . 2024 .{' '}
                  <button className='film-details-link' onClick={() => setShowTrailer(true)} style={{ pointerEvents: 'initial' }}>
                    WATCH THE TRAILER
                  </button>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

const PhotoWithContent = ({ slide, items, isMobile }) => {
  return (
    <div className={`photo-with-content ${isMobile ? 'mobile' : ''}`}>
      <div className='photo-with-content-grid'>
        <div className='photo-with-content-photo'>
          {slide.link ? (
            <a href={slide.link} target="_blank" rel="noopener noreferrer">
              <img src={slide.src} alt={slide.alt} />
            </a>
          ) : (
            <img src={slide.src} alt={slide.alt} />
          )}
        </div>
        <div className='photo-with-content-text'>
          <h2>{slide.title}</h2>
          <div>{slide.content}
            {slide.link && (<div className='link'><a href={slide.link}>{slide.link}</a></div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

const PhotoGrid = ({ photos, renderPhoto, maxPhotos }) => {
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])
  const [index, setIndex] = useState(-1)
  const [isHidden, setIsHidden] = useState(true)
  useEffect(() => {
    if (photos.length > 0) {
      const slides = photos.map((photo) => {
        const item = { ...photo }
        if (photo.content) {
          item.type = 'custom-slide'
        }
        return item
      })
      // console.log(slides)
      setItems(slides)
    }
  }, [photos])
  let props = {
    index,
    open,
    close: () => {
      setOpen(false)
      setIndex(-1)
    },
    slides: items,
    render: {
      slide: ({ slide }) => renderPhoto ? renderPhoto({ slide, items }) : null
    }
  }
  return (
    <>
      <div className='photo-grid'>
        {photos.map((photo, index) => {
          let className = 'photo-item-container'
          if (index > (maxPhotos - 1) && isHidden) {
            className += ' hide'
          }
          return (
            <div className={className} key={`photo-item-${index}`}>
              <div className='photo-item-wrapper'>
                <div 
                  className='photo-item'
                  onClick={() => {
                    setIndex(index)
                    setOpen(true)
                  }}
                >
                  <img src={photo.src} alt={photo.alt} />
                </div>
              </div>
              <div className='photo-item-text'>
                {photo.title && <div className='photo-item-title'>{photo.title}</div>}
                {photo.subtitle && <div className='photo-item-subtitle'>{photo.subtitle}</div>}
              </div>
            </div>
          )
        })}
      </div>
      {maxPhotos && maxPhotos > 0 && <div className='show-more' onClick={() => setIsHidden(!isHidden)}>Show {isHidden ? 'More' : 'Less'}</div>}
      <Lightbox
        {...props}
      />
    </>
  )
}

// const DisplayPhoto = ({ photo }) => {
//   return (
//     <div className='display-photo-section' style={{
//       backgroundImage: `url(${photo.url || ''})`
//     }}>
//       <div className='overlay'></div>
//       { photo.alt && <h2 className='overlay-text'>{photo.alt}</h2> }
//     </div>
//   )
// }

const FullWidthQuote = ({ quote }) => {
  return (
    <div className='full-width-section full-width-quote' data-tone='dark'>
      <div className='full-width-quote-text'>{quote}</div>
    </div>
  )
}

const FullWidthDisplayPhoto = ({ photo, isMobile }) => {
  return (
    <div className='full-width-section'>
      <img src={isMobile && photo.mobileUrl ? photo.mobileUrl : photo.url} alt={photo.alt} />
    </div>
  )
}

const FilmPlayer = () => {
  const [playing, setPlaying] = useState(false)
  const frameRef = useRef(null)

  // Pause the film when the menu covers the page.
  useEffect(() => {
    const pause = () => {
      const frame = frameRef.current
      if (!frame || !frame.contentWindow) return
      frame.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
        '*'
      )
    }
    window.addEventListener('menu:open', pause)
    return () => window.removeEventListener('menu:open', pause)
  }, [])

  if (playing) {
    return (
      <div className='film-player'>
        <iframe
          ref={frameRef}
          src={`https://www.youtube.com/embed/${FILM_YOUTUBE_ID}?autoplay=1&rel=0&enablejsapi=1`}
          title='The Girl and Her Piano - Full Documentary'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
          allowFullScreen
        />
      </div>
    )
  }

  return (
    <button
      className='film-player film-player--facade'
      onClick={() => setPlaying(true)}
      aria-label='Play the full film'
    >
      <img
        src='/assets/gap/the-girl-and-her-piano-landscape-youtube-still-website-s.jpg'
        alt='The Girl and Her Piano'
      />
      <span className='film-player-play' aria-hidden='true'>
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='50' cy='50' r='48' fill='none' stroke='currentColor' strokeWidth='2' />
          <path d='M40 32 L72 50 L40 68 Z' fill='currentColor' />
        </svg>
      </span>
    </button>
  )
}

const Main = () => {
  const { isMobile, isLandscape, isMobileDevice, isSmallScreen } = useOutletContext()
  const [showTrailer, setShowTrailer] = useState(false)
  const [showMoreTextAboutHillary, setShowMoreTextAboutHillary] = useState(true)
  const [showMoreTextAboutFilm, setShowMoreTextAboutFilm] = useState(true)
  useEffect(() => {
    if (isMobileDevice || isSmallScreen) {
      setShowMoreTextAboutFilm(false);
      setShowMoreTextAboutHillary(false);
    }
  }, [isMobileDevice, isSmallScreen]);

  // Arriving from another page with a hash (/#contact, /#watch): the browser
  // looks for the target before React has rendered it, so scroll once mounted.
  useEffect(() => {
    const hash = window.location.hash
    if (!hash) return undefined
    const id = hash.slice(1)
    const timer = window.setTimeout(() => {
      const target = document.getElementById(id)
      if (target) target.scrollIntoView({ behavior: 'smooth' })
    }, 300)
    return () => window.clearTimeout(timer)
  }, []);

  return (
    <>
      <div className='App'>
        {/* The page needs a single h1 saying what it is. The hero carries the
            title as artwork, which a search engine cannot read, and the slider
            was emitting an h1 per slide. */}
        <h1 className='visually-hidden'>
          The Girl and Her Piano, a short documentary from Bhutan
        </h1>
        <Trailer setShowTrailer={setShowTrailer} isMobile={isMobile} isLandscape={isLandscape} />
        <HeroLaurels />
        <div className='content'>
          <main>
            <FullWidthQuote quote='Transcends borders and inspires action and hope towards climate sustainability for future generations' />
            {/* Eighteen laurels, one row, arrows either side. This is the most
                visible place on the site and the band behind it is already blue,
                which is what the white-on-transparent files need. */}
            <LaurelScroller />
            <section id='watch'>
              <div className='content-container'>
                <h2>Watch the film</h2>
                <FilmPlayer />
              </div>
            </section>
            <section id='about'>
              <div className='content-container'>
                <h2>A piano at 4,000 metres in Bhutan</h2>
                <p>This short documentary ‘The Girl and Her Piano' chronicles the extraordinary journey of Hillary O'Sullivan, then 12-year-old Singaporean pianist and climate ambassador, who was invited to perform at Bhutan's Royal Highland Festival in October 2023 for His Majesty, the King of Bhutan. Hillary is the first foreigner and youngest performer to be invited to participate in the festival since its inception in 2016.</p>
                <p>Shot in the remote village of Laya at 4000 metres, ‘The Girl and Her Piano’ highlights the urgent environmental issues confronting the Himalayan region, with a focus on the environmental threat to the glaciers of Bhutan. Despite being the world's first declared carbon-negative nation, Bhutan faces increasing threats from climate change, including glacial melt, flash floods, and unpredictable weather patterns.</p>
                {showMoreTextAboutFilm && (<><p>Playing the piano since she was 3, Hillary is committed to advocating for climate awareness through music, and has performed in diverse locations, including Bunaken Island in Sulawesi, Fenfushi Island in the Maldives and a performance in Antarctica during the Antarctic Climate Expedition in February 2023.</p>
                <p>“Himalayan glaciers could lose up to 80% of their ice by the year 2100 due to global warming,” Hillary explains in the film's narration. “I can feel that the need for climate resilience and sustainability is urgent. As part of the younger generation, I sometimes feel small compared to the huge problem we are facing.”</p></>)}
                {isMobile && <div className='show-more' onClick={() => setShowMoreTextAboutFilm(!showMoreTextAboutFilm)}>Show {showMoreTextAboutFilm ? 'Less' : 'More'}</div>}
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: '/full_width_desktop_1_110a7512c2.jpeg',
              mobileUrl: '/assets/Girl-and-Her-Piano-Documentary-Climate-Change-full1.jpeg'
            }} />
            <section id='about-hillary'>
              <div className='content-container'>
                <h2>Hillary O’Sullivan, pianist and climate ambassador</h2>
                <p>Hillary is a Singaporean pianist whose musical journey began at the age of three. She has travelled to remote islands in Indonesia and the Maldives, performing open-air concerts to the sounds of nature, surrounded by children and their parents.</p>
                <p>She also has a deep love for photography, which led to her 2018 photo-documentary “Above the Sands”, on the people of Bunaken, Indonesia. She interviewed and photographed villagers from all walks of life to gain a deeper understanding of their culture.</p>
                {showMoreTextAboutHillary && (
                  <>
                  <p>In February 2023 she travelled to Antarctica as the youngest Key Opinion Ambassador of the Antarctic Climate Expedition, performing ‘Rhapsody of a Changing Antarctic’, composed for the expedition by Belgian musician Eric Bettens.</p>
                  <p>In October 2023 she was invited to the Royal Highland Festival in Laya, Bhutan, the first foreigner and youngest performer invited since the festival began in 2016. His Majesty The King envisioned the festival to preserve and celebrate Bhutan’s highland culture while promoting the country’s work on climate resilience.</p>
                  <p>Since Bhutan, Hillary has continued to use her music to raise climate awareness. In July 2025 she journeyed to 82 degrees north and played on the Arctic pack ice.</p>
                  <p>She has now performed at both poles and at 4,000 metres in the Himalaya. Her next journey takes her to Sumatra, to highlight what is happening to one of the last great rainforests and the lives that depend on it.</p>
                  </>
                )}
                {isMobile && <div className='show-more' onClick={() => setShowMoreTextAboutHillary(!showMoreTextAboutHillary)}>Show {showMoreTextAboutHillary ? 'Less' : 'More'}</div>}
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: '/full_width_desktop_2_bdc2e93dc3.jpeg',
              mobileUrl: '/assets/Girl-and-Her-Piano-Documentary-Climate-Change-full2.jpeg'
            }} />
            <section id='gallery'>
              <div className='content-container'>
                <h2>Photographs from Laya, Bhutan</h2>
                <PhotoGrid photos={galleryPhotos} maxPhotos={9} isMobile={isMobile} />
              </div>
            </section>
            <FullWidthDisplayPhoto
              isMobile={isMobile}
              photo={{
              url: '/full_width_desktop_3_923f899b35.jpeg',
              mobileUrl: '/assets/Girl-and-Her-Piano-Documentary-Climate-Change-full4.jpeg'
            }} />
            <section id='cast'>
              <div className='content-container'>
                <h2>Cast, Crew and Partners</h2>
                <PhotoGrid photos={castPhotos}
                isMobile={isMobile}
                renderPhoto={({ slide, items }) => (
                  <PhotoWithContent slide={slide} items={castPhotos} isMobile={isMobile} />
                )} />
              </div>
            </section>
            <section id='where' className='map-section'>
              <img className='bhutan-map' src='/assets/gap/bhutan-map.jpg'
                   alt='Map of Bhutan showing Laya in the far north of Gasa district, in the snow along the Tibetan border' />
            </section>

            <section id='contact'>
              <div className='content-container'>
                <h2>Contact</h2>
                <ContactForm />
                <p>For more information, please <a style={{ textDecoration: 'underline' }} href='mailto:info@thegirlandherpiano.com'>email us</a></p>
              </div>
            </section>
          </main>
        </div>
        <SiteFooter />
      </div>
      {showTrailer && (
        <div className='trailer-modal' onClick={() => setShowTrailer(false)}>
          <button className='trailer-modal-close' onClick={() => setShowTrailer(false)} aria-label='Close trailer'>&times;</button>
          <div className='trailer-modal-inner' onClick={(e) => e.stopPropagation()}>
            <div className='video-embed'>
              <iframe
                src={`https://www.youtube.com/embed/${TRAILER_YOUTUBE_ID}?autoplay=1&rel=0`}
                title='The Girl and Her Piano - Trailer'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Main